export const classes = {
  root: "GalleryWindow-root",
  image: "GalleryWindow-imagePreviewSimple-img",
};
